import { useSurveys } from '../queries/useSurveys';
import { useMemo } from 'react';
import { SURVEY_STAGE } from '../types';

export const useChecklistAnnuallySurvey = () => {
  const { data: surveys } = useSurveys();

  const checklistQuarterlySurvey = useMemo(() => {
    if (!surveys) return null;
    return surveys?.find((survey) => survey.stage === SURVEY_STAGE.CHECKLIST_ANNUALLY) || null;
  }, [surveys]);

  return checklistQuarterlySurvey;
};
